import React from 'react';
import PropTypes from 'prop-types';

import { useLabel } from '@atlas/core';
import { TranslateWithLinks } from '@atlas/ui';

const Label = ({ className = '', message, onClick = () => {}, params = {}, render = null }) => {
  const labelMessage = useLabel(message, params);

  return render ? (
    render(labelMessage)
  ) : (
    <span className={className} onClick={onClick}>
      <TranslateWithLinks className={className} onClick={onClick} translate={labelMessage} />
    </span>
  );
};

Label.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  params: PropTypes.object,
  render: PropTypes.func,
};
export default Label;
